import { ApiService } from '../../../services/api.service';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../services/authentication.service';
import { TranslateService } from '@ngx-translate/core';
var DashboardListComponent = (function () {
    function DashboardListComponent(apiService, router, authService, translate) {
        this.apiService = apiService;
        this.router = router;
        this.authService = authService;
        this.translate = translate;
        // month amount to show in graph
        this.monthAmount = 6;
        // activity amount to show in activity list
        this.activityAmount = 2;
        this.monthList = [];
        this.monthListDropdown = [
            { label: 'มกราคม', value: 1 },
            { label: 'กุมภาพันธ์', value: 2 },
            { label: 'มีนาคม', value: 3 },
            { label: 'เมษายน', value: 4 },
            { label: 'พฤษภาคม', value: 5 },
            { label: 'มิถุนายน', value: 6 },
            { label: 'กรกฎาคม', value: 7 },
            { label: 'สิงหาคม', value: 8 },
            { label: 'กันยายน', value: 9 },
            { label: 'ตุลาคม', value: 10 },
            { label: 'พฤศจิกายน', value: 11 },
            { label: 'ธันวาคม', value: 12 }
        ];
        this.SelectDashboard = [
            { label: 'Documents Dashboard', value: 1 },
            // {label: 'SMS Dashboard', value: 2},
            { label: 'Emails Dashboard', value: 3 },
            { label: 'Document Request Dashboard', value: 4 },
        ];
        this.yearList = [];
        this.selectedDate = new Date();
        this.charts_bar_stacked = null;
        this.charts_signing_counter_bar_stacked = null;
        this.charts_signing_counter_line = null;
        this.chartLabels = [];
        this.monthly_loading = false;
        this.daily_loading = false;
        this.bar_stacked_title = '';
        this.charts_signing_counter_bar_stacked_title = '';
        this.charts_transaction_count_title = '';
        this.isShow = false;
    }
    DashboardListComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subs = this.translate.onLangChange.subscribe(function (event) {
            _this.loaddashboard();
        });
        this.loaddashboard();
    };
    DashboardListComponent.prototype.loaddashboard = function () {
        this.dashboards = [
            {
                label: this.translate.instant('DASHBOARD.TITLE'),
                value: null
            },
            { label: this.translate.instant('MENU.EMAIL-DASHBOARD'), value: 3 },
        ];
    };
    DashboardListComponent.prototype.choosedashboard = function () {
        this.keepdashboard = this.selectDashboard;
    };
    DashboardListComponent.prototype.ngOnDestroy = function () {
        this.subs.unsubscribe();
    };
    return DashboardListComponent;
}());
export { DashboardListComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/dashboard/dashboard-list/dashboard-list.component.ts.pre-build-optimizer.js